export default __webpack_public_path__ + "static/media/arrowLeft.d09ce421.svg";